// @flow

import React, { Component } from "react";
import { Button, Space } from "antd";

import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

import "../style/Tip.css";

type State = {
  compact: boolean,
  text: string,
  emoji: string,
  itemNo: string
};

type Props = {
  onConfirm: (comment: { text: string, emoji: string }) => void,
  onOpen: () => void,
  onUpdate?: () => void
};

class Tip extends Component<Props, State> {
  state = {
    compact: false,
    itemNo: 0,
    text: "",
    emoji: ""
  };

  state: State;
  props: Props;

  // for TipContainer
  componentDidUpdate(nextProps: Props, nextState: State) {
    const { onUpdate } = this.props;

    if (onUpdate && this.state.compact !== nextState.compact) {
      onUpdate();
    }
  }

  render() {
    const { onConfirm, onOpen, onClose } = this.props;
    const { compact, text, emoji, itemNo } = this.state;
    onOpen();
    return (
      <div className="Tip">
        {compact ? (
          <div />
        ) : (
            <form
              className="Tip__card"
              onSubmit={event => {
                event.preventDefault();
              }}
            >
              <div>
                <div>
                  {text}
                </div>
              </div>
              <Space>
                <Button type="primary" icon={<CheckOutlined />} onClick={event => {
                  onConfirm({ text, emoji });
                }} />
                <Button type="primary" icon={<CloseOutlined />} onClick={event => {
                  onClose();
                }} />
              </Space>
            </form>
          )}
      </div>
    );
  }
}

export default Tip;



// WEBPACK FOOTER //
// ./src/components/Tip.js